import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import { Sdr } from "@/components/Sdr/Sdr";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxSdrPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxSdrPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxSdrPanel" data-testid="FxSDRPanel" flex={flex}>
			<Sdr {...props} />
		</ContentBlock>
	);
};
